// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function ConfirmDialog(props) {
  return JsxRuntime.jsxs(DialogV5.make, {
              title: props.title,
              isOpen: props.isOpen,
              ariaLabel: props.ariaLabel,
              onDismiss: props.onCancel,
              children: [
                props.body,
                JsxRuntime.jsx(View__Jsx3.make, {
                      mt: "md"
                    }),
                JsxRuntime.jsxs(View__Jsx3.make, {
                      justifyContent: "flexEnd",
                      flexDirection: "row",
                      children: [
                        props.cancelButton,
                        JsxRuntime.jsx(View__Jsx3.make, {
                              mr: "sm"
                            }),
                        props.confirmButton
                      ]
                    })
              ]
            });
}

var make = ConfirmDialog;

exports.make = make;
/* DialogV5 Not a pure module */
